import { useTranslation } from 'react-i18next'
import { formatRelative } from '@/utils/date'

/** Renders an ISO timestamp as a localized relative time ("2h ago"). */
export function RelativeTime({
  at,
  justNowKey = 'overview.justNow',
}: {
  at: string
  justNowKey?: string
}) {
  const { t, i18n } = useTranslation()
  return <span>{formatRelative(at, i18n.language, t(justNowKey))}</span>
}
